import { FC } from "react";

// assets
import { ReactComponent as DownloadSVG } from '../../../assets/download-icon.svg';

//style
import {
    // CurrentLesson,
    DescriptionBox,
    LessonTitle,
    LessonDescription,
    AttachmentLink,
    LinkAttachment,
} from './style/DescriptionTab.style';

const DescriptionTab: FC<{courseItem?: any}> = ({courseItem}) => {

    let title;
    let lesson;
    let attachments = null;

    if (courseItem !== undefined) {
    title = courseItem.title ?? null;
    lesson = courseItem.lesson ?? null;
        if ( lesson !== undefined && lesson !== null){
        attachments = lesson.attachments ?? null;
        }
    }

    const buttonClickHandler = (elementUrl: string) => {
        window.open(
            elementUrl,
            '_blank',
            'noreferrer noopener'
        );
    };

    return (
        <DescriptionBox>
            {courseItem &&
            <>
                {/* We keep this component until analysis of the Designer
                <CurrentLesson>Altre Strategie / Fissiamo gli obbiettivi</CurrentLesson> */}

                <LessonTitle>{title ?? "Title not found"}</LessonTitle>

                { lesson !== null && lesson.description && <LessonDescription dangerouslySetInnerHTML={{__html: lesson.description}} />}
            </>}

            {attachments !== null && 
                attachments.map((element:any, index:number) => {
                    return (<AttachmentLink key={index}>
                                <LinkAttachment onClick={() => buttonClickHandler(element.url)} >
                                    <span>{element.fileName}</span>
                                    
                                    <DownloadSVG />
                                </LinkAttachment>
                            </AttachmentLink>)
                })
            }
        </DescriptionBox>
    );
};


export default DescriptionTab;